import React from 'react';
import { Link } from 'react-router-dom';

const CTAButton = (props) => {
  const { className, icon, content, url, btnType } = props;
  
  if (btnType === 'submit') {
    return (
      <div className={className}>
        <input type="submit" value={content} className='bg-clear no-border text-lt' />
        {icon}
      </div>
    );
  }
  
  return (
    <Link to={url}>
      <button type={btnType} className={className}>
        {content} {icon}
      </button>
    </Link>
  );
}

export default CTAButton;
